import api from './api';

export interface SystemStatus {
  storage: {
    used: string;
    total: string;
  };
  load_average: {
    '1min': string;
    '5min': string;
    '15min': string;
  };
  memory: {
    used: string;
    total: string;
  };
  uptime: string;
  users_count: number;
  cases_count: number;
  tasks_count: number;
}

export const systemStatusService = {
  async getStatus(): Promise<SystemStatus> {
    const { data } = await api.get<SystemStatus>('/system-status');
    return data;
  },
};
